/**
 * Ustawienia pogody: na razie jedno.
 *
 * Osobno od dźwięku, bo to osobny klucz w magazynie i osobna sekcja w menu —
 * a wspólny worek „ustawienia" rósłby do rzeczy, które nie mają ze sobą nic
 * wspólnego poza tym, że są ustawieniami.
 *
 * **Chmury i deszcz idą jednym przełącznikiem, i to nie jest oszczędność
 * wiersza.** Deszcz pada wyłącznie tam, gdzie jest chmura — pyta o to tej samej
 * funkcji szumu — więc „deszcz bez chmur" nie jest stanem, który da się
 * narysować. Odwrotny da się, ale kosztowałby drugi klucz w magazynie za
 * różnicę, której przy domyślnym przybliżeniu i tak nie widać: warstwy nad
 * światem od zoomu 2 w górę nie ma, a deszcz jest.
 *
 * Magazyn, który rzuca wyjątkiem — okno prywatne, przeglądarka trzymająca nic —
 * jest traktowany jak pusty. To samo, co przy głośności: przełącznik nie jest
 * wart wyjątku na drodze do gry.
 */

const STORAGE = 'winged.view';

interface View {
  /** Chmury **i** deszcz — jeden fakt, patrz nagłówek. */
  clouds: boolean;
}

const DEFAULTS: View = { clouds: true };

function stored(): View {
  try {
    const raw = localStorage.getItem(STORAGE);
    if (!raw) return { ...DEFAULTS };
    const saved = JSON.parse(raw) as Partial<View>;
    return { clouds: saved.clouds ?? DEFAULTS.clouds };
  } catch {
    return { ...DEFAULTS };
  }
}

function save(view: View): void {
  try {
    localStorage.setItem(STORAGE, JSON.stringify(view));
  } catch {
    // Nothing to do, and nothing worth saying: the switch still works for this
    // sitting.
  }
}

/** Whether clouds and rain are wanted, as of now. Read before the world is built. */
export function cloudsWanted(): boolean {
  return stored().clouds;
}

/** The switches, as one block to put in the menu. */
export function viewSwitches(onClouds: (wanted: boolean) => void): HTMLElement {
  const view = stored();

  const root = document.createElement('div');
  root.className = 'view-switches';

  const row = document.createElement('label');
  row.className = 'view-row';

  const box = document.createElement('input');
  box.type = 'checkbox';
  box.className = 'view-check';
  box.checked = view.clouds;

  const name = document.createElement('span');
  name.className = 'view-name';
  name.textContent = 'Chmury i deszcz';

  const hint = document.createElement('span');
  hint.className = 'view-hint';
  hint.textContent = 'warstwa nad światem, jej cień i opad spod niej';

  box.addEventListener('change', () => {
    view.clouds = box.checked;
    onClouds(box.checked);
    save(view);
  });

  row.append(box, name, hint);
  root.appendChild(row);
  return root;
}
